<template>
  <input
    type="text"
    :value="value"
    @input="update"
    v-mask="mask"
  >
</template>

<script>
export default {
  props: ['value', 'mask'],

  methods: {
    update (value) {
      this.$emit('input', value);
    },
  },
};
</script>
